// FOUND-11: Typed postMessage envelope (UI-SPEC locked verbatim).
// targetOrigin === '*' is forbidden — UI-SPEC mandate.
// Phase 2: tenant_id added to all message types for parent-page correlation.

export type EmbedMessage =
  | { type: "neko-widget-ready"; tenant_id: string; version: string }
  | { type: "neko-widget-height"; tenant_id: string; height: number }
  | { type: "neko-widget-focus-request"; tenant_id: string; rect: { top: number; height: number } }
  | { type: "neko-widget-lead-submitted"; tenant_id: string; tenantSlug: string; tool: "foerder" | "roi" | "dach"; leadId: string }
  | { type: "neko-widget-error"; tenant_id: string; code: "BOOTSTRAP_FAILED" | "NETWORK" | "CSP" | "UNKNOWN"; message: string }
  | { type: "neko-widget-consent"; tenant_id: string; granted: boolean };

export function postToParent(msg: EmbedMessage, targetOrigin: string): void {
  if (!targetOrigin || targetOrigin === "*") {
    throw new Error("[embed] targetOrigin '*' is forbidden — UI-SPEC mandate");
  }
  if (typeof window === "undefined") return;
  if (window.self === window.top) return;
  window.parent.postMessage(msg, targetOrigin);
}

export function isWidgetMessage(d: unknown): d is EmbedMessage {
  if (!d || typeof d !== "object" || !("type" in (d as object))) return false;
  const t = (d as { type: unknown }).type;
  return typeof t === "string" && t.startsWith("neko-widget-");
}
